import { Decoder, ERR, OK } from "json-decoder";
import { errorDecoder } from "../decoders/errorDecoder";
import { error } from "../domain/error";

const SERVER_ERROR = /^(4.+)|(5.+)$/;

export const handleResponse = async <T>(
  decoder: Decoder<T>,
  response: Response
): Promise<T> => {
  if (response.ok) {
    const json = await response.json();
    const errorResult = errorDecoder.decode(json);
    switch (errorResult.type) {
      case ERR: {
        try {
          const result = await decoder.decodeAsync(json);
          return result;
        } catch (err) {
          throw error((err as any).code, (err as any).message);
        }
      }
      case OK /* error is present */: {
        throw error("Error", errorResult.value.description);
      }
    }
  }
  if (SERVER_ERROR.test(response.status.toString())) {
    const json = await response.json();
    const errorResult = errorDecoder.decode(json);
    switch (errorResult.type) {
      case OK /* error is present */: {
        throw error("Error", errorResult.value.description);
      }
      case ERR: {
        throw error("Error", json.message);
      }
    }
  }
  throw error("Error", "Something Happened");
};
